import { AnimatePresence } from "motion/react";
import SimpleOverlay from "../modal/SimpleOverlay";
import CockpitLayoutComponents from "../CockpitLayoutComponents";
import { usePageFragment } from "../../hooks/CmsHooks";

export function PopupFragment({
  fragmentId,
  show = false,
  onClose = () => {},
  withSectionNav = true,
  direction = "horizontal",
  className,
  style
}) {
  const fragment = usePageFragment(fragmentId);
  if (!fragment) {
    console.warn("Unknown page fragment " + fragmentId);
    return null;
  }

  return (
    <AnimatePresence>
      {show && (
        <SimpleOverlay
          key={"fragment-" + fragmentId}
          close={() => {
            onClose();
          }}
          className="simple-overlay-mini"
        >
          <CockpitLayoutComponents
            withSectionNav={withSectionNav}
            components={fragment.content}
            direction={direction}
            className={className}
            style={style}
          />
        </SimpleOverlay>
      )}
    </AnimatePresence>
  );
}
